import { Gizmo } from "flowy-3-core";
import { Row } from "antd";
import { foracc } from "../../assets/images";

type LoginHeaderProps = {
  gizmo: Gizmo;
};

const LoginHeader = ({ gizmo }: LoginHeaderProps) => {
  return (
    <Row justify={"center"}>
      <img
        src={foracc}
        style={{
          width: "50%",
        }}
      />
    </Row>
  );
};

export default LoginHeader;
